
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.32 2.04c2.66-.122 5.399.827 6.97 2.846C23.287 10.026 19.42 17 14 17c-1.287 0-2.299-.283-3.067-.79a3.754 3.754 0 01-.751-.652l-1.765 5.736a1 1 0 11-1.912-.588l4-13a1 1 0 011.912.588l-1.211 3.936a2.694 2.694 0 00-.029.404c-.003.3.033.668.163 1.018.125.337.334.65.695.889.366.242.968.459 1.965.459 3.715 0 6.712-5.027 3.71-8.886-1.07-1.376-3.1-2.177-5.299-2.076-2.174.1-4.326 1.08-5.618 3.017-.84 1.26-.916 2.462-.67 3.372.262.97.846 1.504 1.21 1.62a1 1 0 01-.608 1.906c-1.204-.384-2.154-1.6-2.533-3.005-.396-1.465-.223-3.263.937-5.003 1.708-2.562 4.505-3.78 7.19-3.905z"}})])
          )
        }
      }
    